import api from '~services/axios';

export default {
  /**
   * 用户列表相关接口
   */
  apiGetUserList: params => api.get('/api/crmuser/query', { params }),
  // 导入
  apiImportUserList: (params, config) =>
    api.post('/api/crmuser/import', params, config),
  // 查询外部用户
  apiSearchUserInfo: params => api.post('/api/crmuser/queryExt', params),
  // 删除用户
  apiDeleteUser: params => api.post('/api/crmuser/delete', params),

  apiAddTeamMember: params => api.post('/api/teamuser/add', params),

  apiAddTeam: params => api.post('/api/team/add', params),

  apiGetTeamList: params => api.get('/api/team/query/all', { params }),

  apiGetParentTeamList: params =>
    api.get('/api/team/query/dropdown', { params }),
  // 获取团队详情
  apiGetTeamDetail: params => api.get('/api/team/detail', { params }),

  // 获取团队成员
  apiGetTeamMembers: params => api.get('/api/teamuser/query', { params }),

  apiDeleteTeamMember: params => api.post('/api/teamuser/delete', params),

  apiDeleteTeam: params => api.post('/api/team/delete', params),

  apiUpdateTeam: params => api.post('/api/team/update', params),

  apiAddUser: params => api.post('/api/crmuser/add', params),

  apiGetRecords: params => api.get('/api/crmoperatelog/query', { params }),

  apiGetDictionaryList: params => api.get('/api/dictionary/query', { params }),

  apiDeleteDictionary: params => api.post('/api/dictionary/delete', params),

  apiAddDictionary: params => api.post('/api/dictionary/add', params),

  apiUpdateDictionary: params => api.post('/api/dictionary/update', params),

  apiGetDictionaryDetailList: params =>
    api.get('/api/category/query', { params }),

  apiGetDictionaryDetail: params =>
    api.get('/api/dictionary/detail', { params }),

  apiDeleteDictionaryDetail: params => api.post('/api/category/delete', params),

  apiUpdateDictionaryDetail: params => api.post('/api/category/update', params),

  apiAddDictionaryDetail: params => api.post('/api/category/add', params),

  apiSortSave: params => api.get('/api/category/sortSave', { params }),

  apiGetTeamConfigList: params =>
    api.get('/api/crmteamcategoryconfig/query', { params }),

  apiGetSecondTeamList: params =>
    api.get('/api/common/query/twoLevelTeam', { params }),

  apiGetAllCategoryList: params =>
    api.get('/api/common/query/allcategory', { params }),

  apiGetAllDictionaryList: params =>
    api.get('/api/common/query/alldictionary', { params }),

  apiSaveAddTeamConfig: params =>
    api.post('/api/crmteamcategoryconfig/add', params),

  apiGetTeamConfigDetail: params =>
    api.get('/api/crmteamcategoryconfig/detail', { params }),

  apiSaveUpdateTeamConfig: params =>
    api.post('/api/crmteamcategoryconfig/update', params),

  apiDeleteTeamConfig: params =>
    api.post('/api/crmteamcategoryconfig/delete', params),

  // 搜索用户 - 支持对外用户
  apiQueryTeamUser: params => api.post('/api/teamuser/queryUser', params),

  // 修改团队成员标签
  apiMemberLabelChange: params => api.post('/api/teamuser/updatelabel', params),
  // 更换团队
  apiTeamChange: params => api.get('/api/teamuser/query/dropdown', params),
  // 保存更换团队
  apiSaveTeamChange: params => api.post('/api/teamuser/transfer', params),

  /**
   * 操作日志相关接口
   */
  apiQueryLog: params => api.post('/api/operationlog/query', params),
  // 获取操作模块
  apiGetMenuTree: params => api.get('/api/operationlog/menu', { params }),
  // 下载(post请求)
  apiDownloadLog: params =>
    api.post('/api/operationlog/export', params, { responseType: 'blob' }),
  // 获取用户
  apiGetUserTree: params => api.get('/api/operationlog/user/tree', { params }),
  // 角色权限相关
  // 分页查看角色下用户
  apiGetRoleUserList: params =>
    api.post('/api/authority/role/user/list', params),
  // 分页查询角色接口
  apiGetRoleList: params => api.post('/api/authority/role/page', params),
  // 删除角色
  apiDelRole: params => api.post('/api/authority/role/del', params),
  // 删除角色下用户
  apiDelRoleUser: params => api.post('/api/authority/role/user/del', params),
  // 添加用户给角色
  apiAddRoleUser: params => api.post('/api/authority/role/user/add', params),
  // 搜索用户
  apiQueryUser: params => api.post('/api/authority/role/queryUser', params),
  // 新增角色
  apiAddRole: params => api.post('/api/authority/role/add', params),
  // 修改角色
  apiEditRole: params => api.post('/api/authority/role/modify', params),

  /**
   * 菜单模块
   */
  // 查询侧边栏完整菜单
  apiGetAsideTree: params => api.get('/api/common/menu', { params }),
  // 查询菜单树
  apiGetSystemTree: params => api.get('/api/systemmenu/tree', { params }),
  // 新增菜单
  apiAddSystemTree: params => api.post('/api/systemmenu/add', params),
  // 更新菜单
  apiUpdateSystemTree: params => api.post('/api/systemmenu/update', params),
  // 查询菜单位置(新增菜单用)
  apiQueryMenuPosition: params =>
    api.get('/api/systemmenu/children', { params }),
  // 删除菜单
  apiDeleteSystemTree: params => api.post('/api/systemmenu/delete', params),
  // 查询菜单详情
  apiQuerySystemTreeDetail: params =>
    api.get('/api/systemmenu/detail', { params }),
  // 查询菜单下的对应资源点
  apiQueryAuth: params => api.get('/api/systemmenu/pageQuery', { params }),

  /**
   * 授权模块
   */
  // 根据角色查询 该角色所拥有的权限
  apiQueryAuthByRoleId: params =>
    api.get('/api/rolemenu/pageQuery', { params }),
  // 授权
  apiToggleAuth: params => api.post('/api/rolemenu/toggleAuth', params),
  // 角色权限查询
  // apiQueryUserAuth: params => api.get('/api/common/auth', { params }),

  /**
   * 产品线模块
   */
  queryProductList: params =>
    api.get('/api/crmProductLine/queryList', { params }),
  queryProductDetail: params =>
    api.get('/api/crmProductLine/detail', { params }),
  enableProductLine: params =>
    api.post('/api/crmProductLine/enableProductLine', params),
  disabledProductLine: params =>
    api.post('/api/crmProductLine/disabledProductLine', params),
  updateRemark: params => api.post('/api/crmProductLine/updateRemark', params),
  queryAdminList: params =>
    api.get('/api/crmProductLine/queryAdminList', { params }),
  addAdmin: params => api.post('/api/crmProductLine/addAdmin', params),
  queryTeamUser: params =>
    api.get('/api/crmProductLine/queryTeamUser', { params }),
  deleteAdmin: params => api.post('/api/crmProductLine/deleteAdmin', params),
  queryBusinessTypeList: params =>
    api.get('/api/crmProductLine/queryBusinessTypeList', { params }),
  queryProductLineType: params =>
    api.get('/api/crmProductLine/queryProductLineType', { params }),
  queryBusinessTypeOperDetail: params =>
    api.get('/api/crmProductLine/queryBusinessTypeOperDetail', { params }),
  queryFileList: params =>
    api.get('/api/crmProductLine/queryFileList', { params }),
  deleteFile: params => api.post('/api/crmProductLine/deleteFile', params),
  fileUpload: params =>
    api.post('/api/crmProductLine/fileUpload', params.params, params.config),
  configBusinessType: params =>
    api.post('/api/crmProductLine/configBusinessType', params),
  fileTop: params => api.post('/api/crmProductLine/fileTop', params),
  cancelFileTop: params =>
    api.post('/api/crmProductLine/cancelFileTop', params),
};
